import apiClient from '../../clienteFebosAPI';

const RESOURCE = '/aduanas/lotes';

export const batchesListSearch = ({
  page, items, filters, order, format, query
}) => {
  const params = apiClient.queryParams(
    {
      filtros: filters,
      pagina: page,
      itemsPorPagina: items,
      orden: order,
      formato: format,
      query
    }
  );
  return apiClient.get(`/v2/buscar/aduana_lote?${params}`, {
    operacionId: 'aduanas.batches.search'
  });
};

export const batchesList = (payload) => {
  let params = null;
  if (payload) {
    params = apiClient.queryParams(payload.params);
  }
  return apiClient.get(`${RESOURCE}?${params}`, {
    operacionId: 'aduanas.batches.list'
  });
};
export const createBatch = (payload) => {
  let params = null;
  if (payload.params) {
    params = apiClient.queryParams(payload.params);
  }
  return apiClient.post(`${RESOURCE}?${params}`, payload.batch, {
    operacionId: 'aduanas.batches.create'
  });
};

export const updateBatch = (payload) => {
  let params = null;
  if (payload.params) {
    params = apiClient.queryParams(payload.params);
  }
  return apiClient.put(`${RESOURCE}/${payload.batch.loteId}?${params}`, payload.batch, {
    operacionId: 'aduanas.batches.put'
  });
};

export const updateBatchEspecificData = (batch) => apiClient.patch(`${RESOURCE}/${batch.loteId}`, batch, {
  operacionId: 'aduanas.batches.update.patch'
});

export const getBatch = ({ loteId, pdf }) => {
  const params = apiClient.queryParams({ pdf });
  return apiClient.get(`${RESOURCE}/${loteId}?${params}`, {
    operacionId: 'aduanas.batches.get'
  });
};

export const cancelBatch = ({ loteId, message }) => apiClient.post(`${RESOURCE}/${loteId}/anular`,
  { mensaje: message },
  { operacionId: 'aduanas.batches.cancel' });

export const returnBatch = ({ loteId, message }) => apiClient.post(`${RESOURCE}/${loteId}/devolver`,
  { mensaje: message },
  { operacionId: 'aduanas.batches.return' });

export const cancelRescue = ({
  loteId,
  message,
  f09Numero,
  f09FechaPago,
  f09MontoPago,
  numeroResolucion,
  fechaResolucion
}) => apiClient.post(`${RESOURCE}/${loteId}/rescatar`,
  {
    mensaje: message,
    f09Numero,
    f09FechaPago,
    f09MontoPago,
    numeroResolucion,
    fechaResolucion
  },
  { operacionId: 'aduanas.batches.rescue' });

export const approveBatch = ({ loteId, description }) => apiClient.post(`${RESOURCE}/${loteId}/aprobar`,
  { descripcion: description },
  { operacionId: 'aduanas.batches.approve' });

export const updateBatchImages = (batch) => apiClient.put(`${RESOURCE}/${batch.loteId}/images`,
  { imagenes: batch.images }, { operacionId: 'aduanas.edit.batches.images' });

export const addBatchImages = (batch) => apiClient.post(`${RESOURCE}/${batch.loteId}/images`,
  { imagenes: batch.images }, { operacionId: 'aduanas.add.batches.images' });

export const deleteBatchImages = (body) => apiClient.delete(
  `${RESOURCE}/${body.loteId}/images/${body.imageId}`,
  { operacionId: 'aduanas.delete.batches.image' }
);

export const updateStatusBatch = ({ batchId, action }) => apiClient.post(
  `${RESOURCE}/${batchId}/${action}`, {}, {
    operacionId: 'aduanas.batchs.update.status'
  }
);

export const rejectBatch = ({ loteId, message }) => apiClient.post(`${RESOURCE}/${loteId}/rechazar`,
  { mensaje: message },
  { operacionId: 'aduanas.batches.reject' });
